import EPopupAccordion from '@/components/everridge/popup/EPopupAccordion';
import DollarCircleIconSolid from '@/components/icons/DollarCircleIconSolid';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FinanceAnalyticsByMonthsResponseDto } from '../../types/finances-dto';
import AnalyticsElement from './AnalyticsElement';
import AnalyticsCardSkeleton from './AnalyticsCardSkeleton';
import CurrencyValue from '../CurrencyValue';

type Props = {
    data?: FinanceAnalyticsByMonthsResponseDto;
    isLoading?: boolean;
};

const AnalyticsIncome: FC<Props> = ({ data, isLoading }) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-4">
            {isLoading && (
                <>
                    {Array.from({ length: 1 }).map((_, index) => (
                        <AnalyticsCardSkeleton key={index} />
                    ))}
                </>
            )}
            {!isLoading && (
                <>
                    <EPopupAccordion
                        icon={DollarCircleIconSolid}
                        label={t('main.finances.components.analytics.components.income.title')}
                        value={<CurrencyValue value={data?.income} asset='other' />}
                        content={<AnalyticsElement values={data?.incomeMonths} />}
                        iconClassName="size-8 shrink-0 flex items-center justify-center rounded-semi-xl bg-[#2EB5661A] fill-[#2EB566] stroke-none"
                    />
                </>
            )}
        </div>
    );
};

export default AnalyticsIncome;
